module.exports = __webpack_public_path__ + "img/CBILogoBlack.5d71bf03.png";